import React, { useState } from 'react';
import { Link, NavLink } from 'react-router';
import { CartProvider, useCart } from 'react-use-cart';

function Navbar() {
  const [open, setOpen] = useState(false);
  const { totalItems } = useCart();
  return (
    <CartProvider>
      <header className="header-area header-sticky">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <nav className="main-nav">
                {/* ***** Logo Start ***** */}
                <Link to="/" className="logo">
                  <h1>Villa</h1>
                </Link>
                {/* ***** Logo End ***** */}
                {/* ***** Menu Start ***** */}
                <ul className={`nav ${open ? 'show' : ''}`}>
                  <li>
                    <NavLink to="/">Home</NavLink>
                  </li>
                  <li>
                    <NavLink to="/properties">Properties</NavLink>
                  </li>
                  <li>
                    <NavLink to="/details">Property Details</NavLink>
                  </li>
                  <li>
                    <NavLink to="/contact">Contact Us</NavLink>
                  </li>
                  <li>
                    <NavLink to="/products">Products</NavLink>
                  </li>
                  <li>
                    <NavLink to="/cart">
                      <i class="fa-solid fa-cart-arrow-down"></i>
                      <span className="text-light">{totalItems}</span>
                    </NavLink>
                  </li>
                </ul>

                <Link
                  className={`menu-trigger ${open ? 'active' : ''}`}
                  onClick={() => setOpen(!open)}
                  style={{ cursor: 'pointer' }}
                >
                  <span>Menu</span>
                </Link>
                {/* ***** Menu End ***** */}
              </nav>
            </div>
          </div>
        </div>
      </header>
    </CartProvider>
  );
}

export default Navbar;
